export default "__VITE_ASSET__Brjc$ZdC__"